import { Component, OnInit, Renderer2 } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router, ActivatedRoute } from '@angular/router';
import Chart from 'chart.js/auto';
import { CommonService } from 'src/app/common.service';
import { TimerService } from 'src/app/timer.service';

@Component({
  selector: 'app-instant-timer',
  templateUrl: './instant-timer.component.html',
  styleUrl: './instant-timer.component.css'
})
export class InstantTimerComponent implements OnInit {
  title = 'ng-chart';
  chart: any = [];
  error: any;
  load: boolean = false;
  strtBtnLoader: boolean = false;
  timerPaused: boolean = true;
  frequency: string;
  campaignId: string;
  campaignList: any = [];
  timerList: any = [];
  deviceList: any = [];
  activeTimer: number = 0;
  timerIndex: number = 0;
  showMsgIndx: any = [];
  allMsgIndx: any = [];
  campaign: any = [];
  timevalue = 10 * 60
  intervalId = 0;
  downloadTimer: any
  focusMessage: any
  focusTimer: any
  black = 0 * 60;
  green = 7 * 60;
  yellow = 2 * 60;
  red = 1 * 60;
  processing: boolean = false;
  is_focus: boolean = true;
  hideTimer: boolean = false;
  remainingTime: number;
  lapsedTime: number = 0;
  duration: number = 600;
  durationOnStart: number = 0;
  lapsedOnStart: number = 0;
  startTime: number = 0;
  frhours: number = 0;
  frminutes: number = 0;
  frseconds: number = 0;
  timerDetails: any;
  constructor(public dialog: MatDialog, private renderer: Renderer2, private router: Router, private route: ActivatedRoute, private dataservice: CommonService, private formBuilder: UntypedFormBuilder, private _snackBar: MatSnackBar, private timerService: TimerService) {
    this.frequency = this.route.snapshot.params.frequency;
    let urlarr = this.frequency.split('-');
    
    if(urlarr.length>1){
      if(urlarr[1] == 'hour' || urlarr[1] == 'hours'){
        this.frhours = parseInt(urlarr[0]);
      }else if(urlarr[1] == 'minute' || urlarr[1] == 'minutes'){
        this.frminutes = parseInt(urlarr[0]);
      }else if(urlarr[1] == 'second' || urlarr[1] == 'seconds'){
        this.frseconds = parseInt(urlarr[0]);
      }
      if(urlarr.length>3 && (urlarr[3]=='minute' || urlarr[3] == 'minutes')){
        this.frminutes = parseInt(urlarr[2]);
      }else if(urlarr.length>3 && (urlarr[3]=='second' || urlarr[3] == 'seconds')){
        this.frseconds = parseInt(urlarr[2]);
      }
      if(urlarr.length>5 && (urlarr[5]=='second' || urlarr[5] == 'seconds')){
        this.frseconds = parseInt(urlarr[4]);
      }
    }
    let totalSeconds = (this.frhours*60*60) + (this.frminutes*60) + this.frseconds;
    this.duration = totalSeconds;
    console.log(this.frequency,this.duration);
  }
  ngOnInit() {
    this.chart = new Chart('customtimer', {
      type: 'pie',
      data: {
        labels: ['Black', 'Green', 'Yellow', 'Red'],
        datasets: [
          {
            label: '# of Votes',
            data: [this.black, this.green, this.yellow, this.red],
            backgroundColor: [
              '#000000',
              '#00A254',
              '#E2D900',
              '#E20000'
            ],
            borderWidth: 0,
          },
        ],
      },
      options: {
        plugins: {
          tooltip: {
            enabled: false,
          },
          legend: {
            display: false
          },
        },
        cutout: '90%',
      },
    });
    this.dataservice.chartglobal = this.chart;
    this.setTimeValue(this.duration);
    this.load = true;
  }
  /* get hours() {
    return Math.floor((this.timevalue / 60)/60) % 60;
  } */
  get minutes() {
    return Math.floor(this.timevalue / 60) % 60;
  }

  get seconds() {
    return Math.round(this.timevalue % 60);
  }
  startCountdown() {
    const interval = setInterval(() => {
      this.remainingTime -= 1;
      if (this.remainingTime <= 0) {
        clearInterval(interval);
      }
    }, 1000);
  }
  starOnlytimer() {
    this.downloadTimer = setInterval(() => {
      // console.log(this.timevalue, this.green, this.yellow, this.red);
      this.lapsedTime++;
      this.timevalue--
      this.black++;
      this.chart.data.datasets[0].data[0]++;
      if (this.timevalue >= (this.yellow + this.red) && this.green > 0) {
        this.green--;
        this.chart.data.datasets[0].data[1] = this.green;
      } else if (this.timevalue >= this.red && this.yellow > 0) {
        this.yellow--;
        this.chart.data.datasets[0].data[2] = this.yellow;
      } else if (this.timevalue >= 0 && this.red > 0) {
        this.red--;
        this.chart.data.datasets[0].data[3] = this.red;
      }
      this.chart.update();
      this.dataservice.chartglobal = this.chart;
      if (this.timevalue < 1) {
        this.timevalue = 0;
        this.pausetimer();
        clearInterval(this.downloadTimer);
      }
    }, 1000);
  }
  setRemainingTimeValue(duration, lapsed) {
    this.black = lapsed;
    let preGreen = duration * 0.7;
    let preYellow = duration * 0.2;
    let preRed = (duration - (preGreen + preYellow));
    this.green = (preGreen - lapsed < 0 ? 0 : preGreen - lapsed);
    this.yellow = (preGreen - lapsed < 0 ? ((preGreen + preYellow) - lapsed < 0 ? 0 : (preGreen + preYellow) - lapsed) : preYellow);
    this.red = ((preGreen + preYellow) - lapsed < 0 ? ((duration) - lapsed < 0 ? 0 : duration - lapsed) : preRed);
    this.chart.data.datasets[0].data[0] = lapsed;
    this.chart.data.datasets[0].data[1] = this.green;
    this.chart.data.datasets[0].data[2] = this.yellow;
    this.chart.data.datasets[0].data[3] = this.red;
    this.chart.update();
  }
  startimer() {
    this.strtBtnLoader = true;
    this.durationOnStart = this.duration;
    this.remainingTime = this.duration - (this.lapsedTime ?? 0);
    console.log(this.duration, this.lapsedTime, this.remainingTime);
    this.startCountdown();
    this.timerPaused = false;
    this.timevalue = this.duration - (this.lapsedTime ?? 0);
    console.log(this.duration, this.timevalue);
    if (this.lapsedTime == 0) {
      this.starOnlytimer();
    } else {
      // this.setRemainingTimeValue(data.duration, -1 * Math.floor(data.lapsed));
      this.setRemainingTimeValue(this.duration, this.lapsedTime);
      this.starOnlytimer();
    }
    this.strtBtnLoader = false;

  }
  pausetimer() {
    this.strtBtnLoader = true;
    this.timerPaused = true;
    this.setRemainingTimeValue(this.duration, (this.lapsedTime ?? 0));
    clearInterval(this.downloadTimer);
    this.strtBtnLoader = false;
    this.setTimerForPause(true, this.duration, -1 * (this.lapsedTime ?? 0));
  }
  setTimerForPause(isPaused, duration, lapsed_time) {
    console.log(isPaused, duration, lapsed_time);
    if (isPaused) {
      this.timevalue = duration + (lapsed_time ?? 0);

      this.setRemainingTimeValue(duration, -1*lapsed_time);
    } else {
      this.setTimeValue((duration + (lapsed_time ?? 0)) < 0 ? 0 : duration + (lapsed_time ?? 0));
    }
  }
  setTimeValue(duration) {
    this.timevalue = duration;
    this.green = this.timevalue * 0.7;
    this.yellow = this.timevalue * 0.2;
    this.red = (this.timevalue - (this.green + this.yellow));
    clearInterval(this.downloadTimer);
    this.chart.data.datasets[0].data[0] = 0;
    this.chart.data.datasets[0].data[1] = this.green;
    this.chart.data.datasets[0].data[2] = this.yellow;
    this.chart.data.datasets[0].data[3] = this.red;
    this.chart.update();
  }
  resetTimer() {
    this.strtBtnLoader = true;
    this.duration = (this.frhours*60*60) + (this.frminutes*60) + this.frseconds;
    this.lapsedTime = 0;
    this.setRemainingTimeValue(this.duration, this.lapsedTime);
    clearInterval(this.downloadTimer);
    this.strtBtnLoader = false;
    this.setTimerForPause(true, this.duration, -1 * (this.lapsedTime ?? 0));
  }
  setTimerTime() {
    this.strtBtnLoader = true;
    this.duration = (this.frhours*60*60) + (this.frminutes*60) + this.frseconds;
    this.lapsedTime = 0;
    this.setRemainingTimeValue(this.duration, this.lapsedTime);
    clearInterval(this.downloadTimer);
    this.timerPaused = true;
    this.strtBtnLoader = false;
    this.setTimerForPause(true, this.duration, -1 * (this.lapsedTime ?? 0));
  }
}
